export default __webpack_public_path__ + "static/media/DSC04925.ba590eda.jpg";